import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { loadingSpinnerConfigInjectionToken } from "moo-shared";
import { LoadingSpinnerComponent, LoadingSpinnerConfig } from "./loading-spinner.component";
import { LoadingInterceptor, LoadingService } from "./loading.service";

@NgModule({
  declarations: [LoadingSpinnerComponent],
  imports: [CommonModule],
  exports: [LoadingSpinnerComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    LoadingService,
    { provide: loadingSpinnerConfigInjectionToken, useClass: LoadingSpinnerConfig }
  ]
})
export class LoadingSpinnerModule { }
